<template>
  <div id="qvv_bundesland_timeline">
    <h1>Trends in den Bundesländern</h1>
    <div class="graph">
      <table>
        <thead>
          <tr>
            <th></th>
            <th :style="{ textAlign: 'right' }" class="bf">Bestätigte Fälle</th>
            <th :style="{ textAlign: 'left' }" class="bf" v-if="!mobile">
              ±&#x200b;gestern
            </th>
            <th :style="{ textAlign: 'right' }" class="bf">
              Schätzung Aktive Fälle<br />
              <small
                ><a
                  href="https://www.corona-ampel.org/methodik/#aktive-f%C3%A4lle"
                  >14-Tage-Fallzahl</a
                ></small
              >
            </th>
            <th :style="{ textAlign: 'left' }">±&#x200b;gestern</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="zeile in tabellendaten"
            :key="zeile.land"
            :class="zeile.land"
          >
            <td>{{ zeile.land }}</td>
            <td :style="{ textAlign: 'right' }" class="bf">
              {{ $fmt(",d")(zeile["bestätigte Fälle_latest"].value) }}
            </td>
            <td :style="{ textAlign: 'left' }" class="bf" v-if="!mobile">
              {{ $fmt("+,d")(zeile["bestaetigte_faelle_diff_latest"].value) }}
            </td>
            <td :style="{ textAlign: 'right' }" class="bf">
              {{ $fmt(",d")(Math.max(zeile["aktive Fälle_latest"].value, 0)) }}
            </td>
            <td
              :style="{ textAlign: 'left' }"
              :class="{
                red: +zeile['aktive Fälle diff_latest'].value > 0,
                lightgreen: +zeile['aktive Fälle diff_latest'].value < 0
              }"
            >
              {{ $fmt("+,d")(zeile["aktive Fälle diff_latest"].value) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <footer>
      <p class="source"><strong>Quelle —</strong> AGES, BMSGPK {{ stand }}</p>
    </footer>
  </div>
</template>

<script>
import bundeslaender_timeline from "./data/bundeslaender_timeline.csv";
import bestaetigte_faelle_summe_aenderung from "./data/bundeslaender_faelle_raw.csv";
import schraegrunter from "./assets/schraegrunter@2x.png";
import gerade from "./assets/gerade@2x.png";
import schraegoben from "./assets/schraegoben@2x.png";
import moment from "moment";

export default {
  name: "BundeslandTable",
  components: {},
  data: () => ({
    bundeslaender_timeline: bundeslaender_timeline,
    mobile: false,
    arrows: {
      schraegrunter,
      gerade,
      schraegoben
    },
    bestaetigte_faelle_summe_aenderung
  }),
  mounted() {
    window.addEventListener("resize", this.update_mobile);
    this.update_mobile();
  },
  methods: {
    update_mobile() {
      this.mobile = window.innerWidth < 700;
    }
  },
  computed: {
    laendernamen() {
      const values = [...new Set(this.bundeslaender_timeline.map(d => d.land))];
      return values.filter(d => d != "Österreich").concat(["Österreich"]);
    },
    datumswerte() {
      return [...new Set(this.bundeslaender_timeline.map(d => d.datum))];
    },
    land_datumswert_wert() {
      return Object.fromEntries(
        this.laendernamen.map(land => [
          land,
          Object.fromEntries(
            this.datumswerte.map(datum => [
              datum,
              this.bundeslaender_timeline.filter(
                d => d.land == land && d.datum == datum
              )[0]
            ])
          )
        ])
      );
    },
    stand() {
      return moment(
        this.bestaetigte_faelle_summe_aenderung.filter(
          d => d.bezcode == "000"
        )[0].heute_datum,
        "YYYY-MM-DD"
      )
        .add(1, "days")
        .format("D.M.");
    },
    stand_aktive() {
      return this.bundeslaender_timeline[0].stand_aktive;
    },
    any_schaetzung_warning() {
      return (
        this.tabellendaten.filter(zeile => zeile.schaetzung_warning).length > 0
      );
    },
    tabellendaten() {
      const r = this.laendernamen.map(land => {
        return {
          land:
            land +
            (this.land_datumswert_wert[land][this.datumswerte.slice(-1)[0]]
              .aktive_Fälle_quelle == "selbstberechnet"
              ? "⚠️"
              : ""),
          "bestätigte Fälle": this.datumswerte.map(dw => ({
            date: dw,
            value: this.land_datumswert_wert[land][dw]["bestätigte_Fälle"]
          })),
          "bestätigte Fälle_latest": this.datumswerte
            .map(dw => ({
              date: dw,
              value: this.bestaetigte_faelle_summe_aenderung.filter(
                d => d.bezcode == this.land_datumswert_wert[land][dw].bezcode
              )[0].heute
            }))
            .slice(-1)[0],
          bestaetigte_faelle_diff_latest: this.datumswerte
            .map(dw => ({
              date: dw,
              value: this.bestaetigte_faelle_summe_aenderung.filter(
                d => d.bezcode == this.land_datumswert_wert[land][dw].bezcode
              )[0].diff
            }))
            .slice(-1)[0],
          "aktive Fälle_latest": this.datumswerte
            .map(dw => ({
              date: dw,
              value: this.land_datumswert_wert[land][dw][
                "bestätigte_Fälle_zweiwochen_diff"
              ]
            }))
            .slice(-1)[0],
          "aktive Fälle diff_latest": this.datumswerte
            .map(dw => ({
              date: dw,
              value: this.bestaetigte_faelle_summe_aenderung.filter(
                d => d.bezcode == this.land_datumswert_wert[land][dw].bezcode
              )[0].diff_14d
            }))
            .slice(-1)[0]
        };
      });

      r.sort((a, b) =>
        a.land == "Österreich"
          ? 100
          : b.land == "Österreich"
          ? -100
          : b["aktive Fälle_latest"].value - a["aktive Fälle_latest"].value
      );
      return r;
    }
  }
};
</script>

<style scoped>
#qvv_bundesland_timeline {
  font-family: Roboto, sans-serif;
  font-size: 16px;
  line-height: 21px;
}

h1 {
  font-family: Roboto, sans-serif;
  font-size: 22px;
  line-height: 29px;
  margin-bottom: 12px;
  margin-top: 0;
}

div.graph {
  margin-top: 24px;
  margin-bottom: 24px;
}

footer {
  background: none;
  padding: 0;
  margin: 0;
  display: flex;
}

p.detail {
  font-size: 14px;
  line-height: 21px;
  margin: 0;
}

footer p.source {
  color: #888;
  text-align: right;
  font-size: 11px;
  line-height: 17px;
  margin: 0;
  flex: 1;
  padding-top: 1px;
  -webkit-text-size-adjust: 100%;
}
p.source strong {
  font-weight: normal;
  text-transform: uppercase;
}

p {
  line-height: 21px;
  margin: 0px;
}

table {
  width: 100%;
}

td,
th {
  vertical-align: baseline;
}
td >>> svg {
  vertical-align: baseline;
  margin-bottom: -1px;
}

table {
  position: relative;
  border-collapse: collapse;
}

thead tr th {
  border-bottom: 2px solid black;
  vertical-align: bottom;
}

th {
  text-align: left;
}

tbody tr th,
tbody tr td {
  border-top: 1px solid #ddd;
}

tr th,
tr td {
  padding: 5px 5px 0px;
}

tr th:last-child,
tr td:last-child {
  padding-right: 0;
}

tr.Österreich th,
tr.Österreich td {
  border-top: 1px solid black;
}

td.bf,
th.bf {
  padding-right: 5px;
}

td.red {
  background: #ca5775;
  border-top: transparent;
  color: white;
}

td.orange {
  background: #71424f;
  border-top: transparent;
  color: white;
}

td.yellow {
  background: #bb8b98;
  border-top: transparent;
  color: white;
}

td.lightgreen {
  background: #8cc599;
  border-top: transparent;
  color: white;
}

.outlook img {
  max-height: 1em;
  max-width: 1em;
}

td.pct {
  width: 40px;
}

@media (max-width: 700px) {
  table {
    font-size: 12px;
    line-height: 16px;
  }
  tr th,
  tr td {
    padding: 4px 5px 0px;
  }

  p.detail {
    font-size: 11px;
    line-height: 14px;
  }
}
</style>
